module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_WoodMatted.d27a56da.jpg";